import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-forgotusername',
    templateUrl: './forgotusername.component.html',
    styleUrls: ['./forgotusername.component.css'],
    standalone: false
})
export class ForgotusernameComponent implements OnInit {
  serverErrorMessages: string;
  successMessage: string;
  userName: string;

  constructor(private loginservice: LoginService, private router: Router) { }
  
  ngOnInit(): void {
    if(this.loginservice.isLoggedIn()){
     //console.log("Already logged in! Log Out first");
      this.loginservice.getUserProfile().subscribe(
        res => {
          this.router.navigateByUrl('/home');
          
        },
        err => {
         //console.log('Did not get user', err);
        });
    }
  }

  onSubmit(form) {
   //console.log('Inside onSubmit',form.value);
    this.loginservice.forgotUsername(form.value).subscribe(
      data => {
        this.successMessage = data.message;
       //console.log('Got resp from backend', data);
        setTimeout(() => {
          this.router.navigateByUrl('forgotusername');
         //console.log('Bye bye');
        }, 3000)
      },
      err => {
        this.serverErrorMessages = err.error.message;
       //console.log('Error sending Email', err)
      }
    )
  }

}
